/* 🤖 this file was generated by svg-to-ts*/
export const iconList: {
  name: 'list';
  data: string;
} = {
  name: 'list',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 12a1 1 0 010 2H2a1 1 0 010-2zm11 0a1 1 0 010 2H7a1 1 0 010-2zm0-5a1 1 0 010 2H7a1 1 0 010-2zM3 7a1 1 0 010 2H2a1 1 0 010-2zm11-5a1 1 0 010 2H7a1 1 0 010-2zM3 2a1 1 0 010 2H2a1 1 0 010-2z"/></svg>`,
};
